import { CarpaySavedPaidOrders } from '@customTypes/carpaySavedPaidOrders'
import {
    SESSION_STORAGE_getCarpayPaidOrders,
    SESSION_STORAGE_setCarpayPaidOrders
} from '@sessionStorage/carpayPaidOrders.sessionStorage'
import { DateTime } from 'luxon'

// After how much time we clean the already paid orders
const PAID_ORDERS_EXPIRATION_DAYS = 2

// Some orders are paid and the adyen confirmation takes a while to come, so in the meantime we save the paid orders in the session storage.
// This way, if we still receive the orders as UNPAID or INCOMPLETE we know it has already been paid until Adyen confirms it.
export const savePaidOrder = (orderId: string) => {
    const paidOrders: CarpaySavedPaidOrders = SESSION_STORAGE_getCarpayPaidOrders() ?? {}
    const now = DateTime.now().toMillis()

    if (!paidOrders[orderId]) paidOrders[orderId] = now
    else delete paidOrders[orderId]

    SESSION_STORAGE_setCarpayPaidOrders(paidOrders)
}

export const getSavedPaidOrders = () => {
    const paidOrders: CarpaySavedPaidOrders = SESSION_STORAGE_getCarpayPaidOrders() ?? {}
    return paidOrders
}

export const isOrderSavedInPaidOrders = (orderId: string) => {
    const paidOrders: CarpaySavedPaidOrders = SESSION_STORAGE_getCarpayPaidOrders() ?? {}
    return !!paidOrders[orderId]
}

export const removeOrderFromSavedPaidOrders = (orderId: string) => {
    const paidOrders: CarpaySavedPaidOrders = SESSION_STORAGE_getCarpayPaidOrders() ?? {}
    delete paidOrders[orderId]
    SESSION_STORAGE_setCarpayPaidOrders(paidOrders)
}

export const clearSavedPaidOrders = () => {
    const paidOrders: CarpaySavedPaidOrders = SESSION_STORAGE_getCarpayPaidOrders() ?? {}

    Object.keys(paidOrders).forEach((orderId) => {
        const timestamp = DateTime.fromMillis(paidOrders[orderId])

        if (timestamp.diffNow().days > PAID_ORDERS_EXPIRATION_DAYS) delete paidOrders[orderId]
    })

    SESSION_STORAGE_setCarpayPaidOrders(paidOrders)
}
